import { Form, Formik } from "formik";
import FormikInput from "../../../Formik/FormikInput";
import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";

import cameraIcon from "../../../../Images/camera.svg";

import Contact from "./Contact";
import { CREATE_NEW_CONTACT_RADIO_OPTIONS } from "../../../../utilities/constants";
import { newContactValidationSchema } from "../../../../utilities/Validation Schema/contactFormValidation";
import UploadedImage from "../../../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../../../utilities/fileToBase64";

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 130px;
  height: 35px;
  margin-right: 20px;
  margin-top: 25px;
`;
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="radio"] {
    accent-color: #ff5837;
  }
`;
const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
`;
const ImageContainer = styled.div`
  border-radius: 10px;
  background-color: #f5f5f5;
  border: 1px solid #cbcbcb;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 193px;
  height: 195px;
  margin-right: 20px;
  max-width: 140px;
`;
const defaultValues = {
  type: "contact",
  title: "",
  function: "",
  phone: "",
  mobile: "",
  email: "",
  comment: "",
  // optional
  street: "",
  street2: "",
  country_id: "",
  state_id: "",
  zip: "",
  city: "",
  image_1920: "",

  country: "",
  state: "",
};
const CreateNewContact = ({
  closeModal,
  handleAddContact,
  selectedContactData,
  handleRemove,
  disableInputs,
  contactIncommingOptions,
  setContactIncommingOptions,
}) => {
  // const { language, translations } = useLanguage();
  // const t = translations[language];

  // const { sessionInfo } = useSession();
  // const { company_id, context, user_id } = sessionInfo;

  const image1920Ref = useRef();

  const [initialValues, setInitialValues] = useState(defaultValues);

  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("image_1920", base64));
    }
    if (
      file &&
      !["image/png", "image/jpeg", "image/svg+xml"].includes(file.type)
    ) {
      alert("Unsupported file type. Please select a PNG, JPG, or SVG file.");
      return;
    }
  };
  const handleSubmitData = async (
    { values, validateForm, setErrors, resetForm, setFieldTouched },
    modalStatus
  ) => {
    const errors = await validateForm(values);
    if (Object.keys(errors).length === 0) {
      handleAddContact({ ...values, isDeleted: false }, modalStatus);
      resetForm({ ...defaultValues });
      return;
    }

    Object.keys(errors).forEach((key) => {
      setFieldTouched(key, true);
    });
    setErrors(errors);
  };
  const handleChangeType = async ({ values, type, setFieldValue }) => {
    //  onchange need to integrated but it has no functionality on the existing values
  };
  const handleExistingContactOptions = () => {
    const { country = false, state = false } = selectedContactData;
    const countryList = contactIncommingOptions.country_id || [];
    const stateList = contactIncommingOptions.state_id || [];
    if (country) {
      const countryExist = contactIncommingOptions?.country_id?.find(
        (item) => item.value === country.value
      );
      if (!countryExist) {
        setContactIncommingOptions((prev) => ({
          ...prev,
          country_id: [...countryList, country],
        }));
      }
    }
    if (state) {
      const stateExist = contactIncommingOptions?.state_id?.find(
        (item) => item.value === state.value
      );
      if (!stateExist) {
        setContactIncommingOptions((prev) => ({
          ...prev,
          state_id: [...stateList, state],
        }));
      }
    }
  };
  useEffect(() => {
    if (selectedContactData) {
      setInitialValues({ ...defaultValues, ...selectedContactData });
      handleExistingContactOptions();
    } else {
      setInitialValues({ ...defaultValues });
    }
  }, [selectedContactData]);

  return (
    <div>
      <div
        className="container"
        style={{ maxWidth: "1000px", padding: "10px" }}
      >
        <FormContainer className="row g-3 px-2">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={newContactValidationSchema}
          >
            {({
              values,
              setFieldValue,
              setErrors,
              validateForm,
              setFieldError,
              setFieldTouched,
              resetForm,
            }) => (
              <Form>
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="d-flex ">
                    <div className="d-flex flex-column mb-3">
                      <div>
                        {" "}
                        <h3 className="modal-title mb-2">Create New Contact</h3>
                      </div>
                      <div className="d-flex mt-2 mb-2">
                        {CREATE_NEW_CONTACT_RADIO_OPTIONS.map((radioOption) => (
                          <div key={radioOption.value} className="me-2">
                            <input
                              type="radio"
                              id={radioOption.value}
                              checked={values.type === radioOption.value}
                              name="type"
                              disabled={disableInputs}
                              onChange={() => {
                                setFieldValue("type", radioOption.value);
                                handleChangeType({
                                  values,
                                  type: radioOption.value,
                                  setFieldValue,
                                });
                              }}
                            />
                            <label htmlFor={radioOption.value} className="ms-2">
                              {radioOption.label}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div>
                        <div className="col-12">
                          <StyledLabel className="form-label mt-2">
                            Contact Name
                          </StyledLabel>
                          <FormikInput disabled={disableInputs} name="name" />
                        </div>
                      </div>
                    </div>
                    <ImageContainer
                      onClick={() => {
                        if (!disableInputs) image1920Ref.current.click();
                      }}
                      className="ms-4"
                    >
                      <UploadedImage src={values.image_1920 || cameraIcon}>
                        <input
                          ref={image1920Ref}
                          type="file"
                          name="image_1920"
                          hidden
                          accept=".png, .jpg, .svg"
                          onChange={(e) =>
                            handleChangeimage1920(e, setFieldValue)
                          }
                        />
                      </UploadedImage>
                    </ImageContainer>
                  </div>
                  <hr />

                  <Contact
                    disabled={disableInputs}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    contactIncommingOptions={contactIncommingOptions}
                  />
                </div>
                <div className="d-flex justify-content-end align-items-center mb-4">
                  <ActionButton type="button" onClick={() => closeModal(false)}>
                    Discard
                  </ActionButton>
                  {selectedContactData && (
                    <ActionButton
                      type="button"
                      onClick={() => handleRemove(values)}
                    >
                      Remove
                    </ActionButton>
                  )}
                  <ActionButton
                    type="button"
                    onClick={() =>
                      handleSubmitData(
                        {
                          values,
                          setErrors,
                          validateForm,
                          setFieldError,
                          resetForm,
                          setFieldTouched,
                        },
                        false
                      )
                    }
                  >
                    Save and close
                  </ActionButton>
                  <ActionButton
                    type="button"
                    onClick={() =>
                      handleSubmitData(
                        {
                          values,
                          setErrors,
                          validateForm,
                          setFieldError,
                          resetForm,
                          setFieldTouched,
                        },
                        true
                      )
                    }
                  >
                    Save and new
                  </ActionButton>
                </div>
              </Form>
            )}
          </Formik>
        </FormContainer>
      </div>
    </div>
  );
};

export default CreateNewContact;
